//https://babeljs.io/docs/usage/polyfill/
// "If you are using ES6’s import syntax in your application’s entry point, you should instead import the polyfill at the top of the entry point to ensure the polyfills are loaded first"
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router';
import history from './utils/history';
import PageWrapper from './pages/PageWrapper';
import axios from 'axios';
import miscUtils from './utils/miscUtils';
import CryptoJS from 'crypto-js';
import './styles/build.less';

const APP_KEY = '02af4256-78af-413f-acf8-19344ad514fd';

function hashLinkScroll() {
    var { hash } = window.location;

    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView();
        } else {
            window.scrollTo(0,0);
        }
    }, 0);
}

axios.post('/config').then((response) => {

    // Decrypt the JSON config data
    var reb64 = CryptoJS.enc.Hex.parse(response.data);
    var bytes = reb64.toString(CryptoJS.enc.Base64);
    var decrypt = CryptoJS.AES.decrypt(bytes, APP_KEY);
    var plain = decrypt.toString(CryptoJS.enc.Utf8);
    var json = JSON.parse(plain);
    response.data = json;

    // Load google script only if needed for google maps
    if (!response.data.mapDisable && !response.data.mapMetaCartaUrl) {
        miscUtils.loadScript('https://www.google.com/jsapi', () => {
            console.log('Loaded google api via https://www.google.com/jsapi');
            if (google) {
                google.load('maps', '3', {other_params : 'libraries=places&key=AIzaSyBCAS32QJHyVJwMG8W6YiFDkdIN7-JzNr8'});
            }
        })
    }

    window._FFT_webServiceUrl = response.data.webServiceUrl;
    window._sentimentModel = response.data.sentimentModel;
    window._mapDisable = response.data.mapDisable;
    window._mapMetaCartaUrl = response.data.mapMetaCartaUrl;
    window._mapMetaCartaMapFile = response.data.mapMetaCartaMapFile;
    window._tikaExtractionUrl = response.data.tikaExtractionUrl;
    window._maxRecentDocs = response.data.maxRecentDocs;
    window._googleAnalyticsId = response.data.googleAnalyticsId;
    window._externalUrlsDisable = response.data.externalUrlsDisable;
    window._mailServerDisable = response.data.mailServerDisable;
    window._feedbackDisable = response.data.feedbackDisable;

    ReactDOM.render(<Router history={history}>
        <PageWrapper/>
    </Router>, document.getElementById('contentWrapper'));
});


